import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { PlusBlurbMessage } from "scmp-app/components/plus/blurb-popup";
import { AgendaBlock } from "scmp-app/components/plus/home/agenda-block";
import { DailyPulseBlock } from "scmp-app/components/plus/home/daily-pulse-block";

export const plusGlobalCss = css`
  body {
    background-color: #f7f6ef;
  }
`;

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  margin-block-start: 12px;
`;

export const Wrapper = styled.div`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: flex;
    flex-flow: column nowrap;

    max-inline-size: 1272px;
    margin-inline: auto;
    padding-inline: 32px;
  }
`;

export const PlusBlurbMessageWrapper = styled.div`
  ${theme.breakpoints.up("tablet")} {
    display: flex;
    justify-content: center;

    margin-block-end: 32px;
    padding-inline: 32px;
  }
`;

export const StyledPlusBlurbMessage = styled(PlusBlurbMessage)``;

export const FirstRow = styled.div`
  position: relative;

  display: grid;
  grid:
    "daily-pulse" min-content
    " agenda" min-content
    / 1fr;
  gap: 32px;
  ${theme.breakpoints.up("desktop")} {
    grid:
      "daily-pulse agenda" 1fr
      / 0.36fr 0.64fr;
  }
  ${theme.breakpoints.up("mediumDesktop")} {
    grid:
      "daily-pulse agenda" 1fr
      / 0.394fr 0.606fr;
  }
`;

export const SecondRow = styled.div`
  display: flex;
  flex-flow: column;
  gap: 32px;

  margin-block: 40px 0;

  ${theme.breakpoints.up("desktop")} {
    flex-flow: row nowrap;

    margin-block: 40px 20px;
  }
`;

export const StyledDailyPulseBlock = styled(DailyPulseBlock)`
  grid-area: daily-pulse;
`;

export const StyledAgendaBlock = styled(AgendaBlock)`
  grid-area: agenda;

  inset-inline-start: 0;

  block-size: 100%;
  max-block-size: 795px;
  ${theme.breakpoints.up("desktop")} {
    position: absolute;

    max-block-size: none;
  }
`;

export const FeaturedOpinion = styled.div`
  flex: 1 1 100%;
  ${theme.breakpoints.up("desktop")} {
    flex: 1 1 50%;
  }
`;

export const HighlightFromSCMPPlus = styled.div`
  flex: 1 1 100%;
  ${theme.breakpoints.up("desktop")} {
    flex: 1 1 50%;
  }
`;
